<template>
  <ul class="list-reset lg:flex navigation-hr">
    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_USERS)"
      tag="li"
      to="/users"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-user" />
      <span>Users</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_ROLES)"
      tag="li"
      to="/roles"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-group" />
      <span>Roles</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_PERMISSIONS)"
      tag="li"
      to="/permissions"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-permission" />
      <span>Permissions</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_ORDERS)"
      tag="li"
      to="/orders"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-orders-issues" />
      <span>Orders</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_MY_RESTAURANT)"
      tag="li"
      to="/my-restaurant"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer m-w-110"
    >
      <i class="mr-2 icon-ic icon-ic-my-restaurant" />
      <span>My Restaurant</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_MENUS)"
      tag="li"
      to="/menu"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-menu" />
      <span>Menu</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_HISTORIES)"
      tag="li"
      to="/history"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-history" />
      <span>History</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_ORDERS)"
      tag="li"
      to="/business-hours"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-timer" />
      <span>Business Hours</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_SEE_ACTIVITY_LOGS)"
      tag="li"
      to="/activity"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-history" />
      <span>Activity</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_HISTORIES)"
      tag="li"
      to="/downloads"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-download" />
      <span>CSV Download</span>
    </router-link>

    <router-link
      v-if="matchesUserPermission(USER_PERMISSIONS.CAN_CRUD_USERS)"
      tag="li"
      to="/reg"
      class="flex mr-0 lg:mr-10 py-4 lg:py-6 px-4 lg:px-0 self-center cursor-pointer"
    >
      <i class="mr-2 icon-ic icon-ic-user" />
      <span>Registration</span>
    </router-link>
  </ul>
</template>

<script>
import config from '@src/config';

export default {
  data() {
    return {
      USER_PERMISSIONS: config.PERMISSIONS,
    };
  },
  methods: {
    matchesUserPermission(routePermission) {
      const userPermissions = this.$store.getters['auth/permissions'];

      let hasPermission = false;

      hasPermission = userPermissions.includes(routePermission);

      return hasPermission;
    },
  },
};
</script>
